import React from 'react'
import { Route } from 'react-router-dom'
import NavLink from 'app/components/util/lgy-nav-link/LgyNavLink'

import AssignmentsSubNav from './AssignmentsSubNav'

const MainLeftNav = (props) =>
  <nav className='main-left-nav'>
    <ul className='usa-sidenav-list'>
      <li>
        <NavLink
          activeClassName={props.location.pathname === '/lgyhub/appraiser' ? 'usa-current' : ''}
          to='/lgyhub/appraiser'>
          Appraiser Workspace
        </NavLink>
      </li>
      <li>
        <NavLink activeClassName='usa-current' to='/lgyhub/appraiser/profile'>
          Personal/Business Profile
      </NavLink>
      </li>
      <li>
        <NavLink activeClassName='usa-current' to='/lgyhub/appraiser/geographic-areas'>
          Geographic Areas
      </NavLink>
      </li>
      <li>
        <NavLink activeClassName='usa-current' to='/lgyhub/appraiser/unavailability'>
          Unavailability Dates
      </NavLink>
      </li>
      <li>
        <NavLink
          className={props.match.params[0] === 'locate-cases' ? 'usa-current' : ''}
          to='/lgyhub/appraiser/locate-cases/canceled-90-days'>
          Locate Cases
      </NavLink>
      </li>
      <Route
        exact
        path='/lgyhub/appraiser/locate-cases/(canceled-90-days|all-90-days|with-uploads)?'
        component={AssignmentsSubNav} />
    </ul>
  </nav>

export default MainLeftNav
